import {Component, inject} from '@angular/core';
import {DIALOG_REF, DialogRef} from '../../../../../../shared/components/modals/dialog/model/dialog.model';
import {Message} from 'primeng/message';
import {AppDateInputComponent} from '../../../../../../shared/components/input/date-input/date-input.component';
import {AppTextInputComponent} from '../../../../../../shared/components/input/text-input/text-input.component';
import {Button} from 'primeng/button';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {DateTime} from 'luxon';
import {VehicleReleaseModalResult} from '../../model/vehicle-release-modal-result.model';

@Component({
  selector: 'app-vehicle-release-modal',
  imports: [
    Message,
    AppDateInputComponent,
    AppTextInputComponent,
    Button,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './vehicle-release-modal.component.html',
})
export class VehicleReleaseModalComponent {
  private readonly dialogRef = inject(DIALOG_REF) as DialogRef<VehicleReleaseModalResult>;

  private get now(): DateTime {
    return DateTime.now();
  }

  protected readonly vehicleReleaseForm = new FormGroup({
    vehicleReleaseDate: new FormControl<DateTime>(this.now, {validators: [Validators.required], nonNullable: true}),
    vehicleReleasePerson: new FormControl<string>('', {validators: [Validators.required], nonNullable: true})
  })

  protected onVehicleReleaseSubmit(): void {
    const {vehicleReleaseDate, vehicleReleasePerson} = this.vehicleReleaseForm.getRawValue();
    const payload = new VehicleReleaseModalResult(vehicleReleaseDate, vehicleReleasePerson);

    this.dialogRef.close(payload);
  }

  protected onVehicleReleaseCancel(): void {
    this.dialogRef.close();
  }
}
